import { render, staticRenderFns } from "./LeavingMsg.vue?vue&type=template&id=ce118eb4&scoped=true"
import script from "./LeavingMsg.vue?vue&type=script&lang=js"
export * from "./LeavingMsg.vue?vue&type=script&lang=js"
import style0 from "./LeavingMsg.vue?vue&type=style&index=0&id=ce118eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce118eb4",
  null
  
)

export default component.exports